export class ObjectNotFoundError extends Error {
  constructor() {
    super('Object could not be found!');
  }
}
